// GENERATED CODE - DO NOT MODIFY BY HAND
// For all changes please modify icons-generator/src/main/resources/web/groupIcons.template file first and regenerate.
import { type LazyIcon, type LazyIconsGroup } from '@DS/components/icons/icons.types'
import { svgLazyLoader } from '@Utils/icons'

const Bike = svgLazyLoader('transports/bike')
const BikeNested = svgLazyLoader('transports/bike_nested')
const Boat = svgLazyLoader('transports/boat')
const Bus = svgLazyLoader('transports/bus')
const BusFront = svgLazyLoader('transports/bus_front')
const BusFrontFull = svgLazyLoader('transports/bus_front_full')
const BuslineDefault = svgLazyLoader('transports/busline_default')
const BuslineFull = svgLazyLoader('transports/busline_full')
const CableCar = svgLazyLoader('transports/cable_car')
const Car = svgLazyLoader('transports/car')
const CarBus = svgLazyLoader('transports/car_bus')
const Funicular = svgLazyLoader('transports/funicular')
const MetroDefault = svgLazyLoader('transports/metro_default')
const MetroFull = svgLazyLoader('transports/metro_full')
const MetrolineDefault = svgLazyLoader('transports/metroline_default')
const MetrolineFull = svgLazyLoader('transports/metroline_full')
const Taxi = svgLazyLoader('transports/taxi')
const TerDefault = svgLazyLoader('transports/ter_default')
const TerFull = svgLazyLoader('transports/ter_full')
const TerSimple = svgLazyLoader('transports/ter_simple')
const Train = svgLazyLoader('transports/train')
const TrainBus = svgLazyLoader('transports/train_bus')
const TrainCancelled = svgLazyLoader('transports/train_cancelled')
const TrainFull = svgLazyLoader('transports/train_full')
const TramlineDefault = svgLazyLoader('transports/tramline_default')
const TramwayDefault = svgLazyLoader('transports/tramway_default')
const TramwayFull = svgLazyLoader('transports/tramway_full')
const TramwaylineFull = svgLazyLoader('transports/tramwayline_full')
const TransportType = svgLazyLoader('transports/transport_type')
const Vtc = svgLazyLoader('transports/vtc')

const ALL_TRANSPORTS_ICONS = [
  'bike',
  'bike_nested',
  'boat',
  'bus',
  'bus_front',
  'bus_front_full',
  'busline_default',
  'busline_full',
  'cable_car',
  'car',
  'car_bus',
  'funicular',
  'metro_default',
  'metro_full',
  'metroline_default',
  'metroline_full',
  'taxi',
  'ter_default',
  'ter_full',
  'ter_simple',
  'train',
  'train_bus',
  'train_cancelled',
  'train_full',
  'tramline_default',
  'tramway_default',
  'tramway_full',
  'tramwayline_full',
  'transport_type',
  'vtc',
] as const
export type TransportsIcon = (typeof ALL_TRANSPORTS_ICONS)[number]

const ICONS: LazyIconsGroup<TransportsIcon> = {
  bike: Bike,
  bike_nested: BikeNested,
  boat: Boat,
  bus: Bus,
  bus_front: BusFront,
  bus_front_full: BusFrontFull,
  busline_default: BuslineDefault,
  busline_full: BuslineFull,
  cable_car: CableCar,
  car: Car,
  car_bus: CarBus,
  funicular: Funicular,
  metro_default: MetroDefault,
  metro_full: MetroFull,
  metroline_default: MetrolineDefault,
  metroline_full: MetrolineFull,
  taxi: Taxi,
  ter_default: TerDefault,
  ter_full: TerFull,
  ter_simple: TerSimple,
  train: Train,
  train_bus: TrainBus,
  train_cancelled: TrainCancelled,
  train_full: TrainFull,
  tramline_default: TramlineDefault,
  tramway_default: TramwayDefault,
  tramway_full: TramwayFull,
  tramwayline_full: TramwaylineFull,
  transport_type: TransportType,
  vtc: Vtc,
}

export const isTransportsIcon = (transportsKey: string): transportsKey is TransportsIcon =>
  ALL_TRANSPORTS_ICONS.includes(transportsKey as TransportsIcon)

export const getTransportsIcon = (transportsKey: TransportsIcon): LazyIcon => ICONS[transportsKey]

export const getTransportsIcons = (): LazyIconsGroup<TransportsIcon> => ICONS
